let updateUseHydration = false;

export function setUpdateIsUsignHydration(hydration: boolean) {
  updateUseHydration = hydration;
}

export function updateIsUsingHydration() {
  return updateUseHydration;
}
